import ModelUtil from '@leverege/model-util';
import { FontModel } from '@leverege/ui-style-elements';
import ColumnModel from "./ColumnModel.js";
import Attributes from "../../attribute/Attributes.js";
import Formatters from "../../attribute/formatter/Formatters.js";
import Util from "./Util.js";
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

// These are common, make them once
const base = {
  ...ColumnModel,
  getName,
  ...ModelUtil.createAllValue('formatter'),
  ...ModelUtil.createAllValue('unit/color', 'unitColor'),
  ...ModelUtil.createAllValue('unit/font', 'unitFont'),
  ...ModelUtil.createAllValue('unit/align', 'unitAlign'),
  ...ModelUtil.createAllValue('unit/spacing', 'unitSpacing')
};
delete base.create;

/**
 * Creates a Model for a given unit type.
 */
function createFor(unitType) {
  // Get and use a new unit formatter
  const formatter = Formatters.createFormatterModel(unitType);
  function create(attrName, objectType) {
    return ColumnModel.create(Util.getColumnTypeForType(unitType), {
      attrName,
      objectType,
      formatter,
      unit: {
        color: null,
        font: FontModel.create(),
        align: 'center',
        spacing: '4px'
      }
    });
  }
  return {
    create,
    ...base
  };
}
export default {
  createFor,
  ...base
};